import { type FC } from 'react';
import ReactMarkdown, { type Components } from 'react-markdown';

const components: Components = {
  p: ({ children }) => <>{children}</>,
  a: ({ href, children }) =>
    href?.startsWith('https://') ? (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="pointer-events-auto underline"
      >
        {children}
      </a>
    ) : (
      <>{children}</>
    ),
};

/** Attribution markdown whose only markup is https links; anything else shows as text. */
const AttributionText: FC<{ markdown: string }> = ({ markdown }) => (
  <ReactMarkdown
    allowedElements={['p', 'a']}
    unwrapDisallowed
    components={components}
  >
    {markdown}
  </ReactMarkdown>
);

export default AttributionText;
